import {useLocation, useParams} from "react-router";

import {isEmpty} from "@pg-mono/nodash";
import {parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";
import {IOfferFriendlySubFilterGeneralUrlParams} from "@pg-mono/rp-routes";

import {FloorChoice} from "../../real_estate/types/FloorChoice";
import {getFloorChoiceText} from "../../real_estate/utils/get_floor_choice_text";
import {offerUrlBuilder} from "../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital} from "../helpers/OfferType";
import {getFloorChoiceByOfferListSubType} from "../list/helpers/sub_type/transform/get_floor_choice_by_offer_list_sub_type";
import {getOfferListSubTypeByFloorChoice} from "../list/helpers/sub_type/transform/get_offer_list_sub_type_by_floor_choice";
import {OfferType} from "../types/OfferType";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

interface IProps {
    offerType: OfferType | null;
    regionName: string;
    regionSlug: string;
    availableFloorTypes: FloorChoice[];
}

const getFloorChoiceFromSlug = (offerListSubFilter?: string): FloorChoice | null => {
    try {
        return offerListSubFilter ? getFloorChoiceByOfferListSubType(offerListSubFilter) : null;
    } catch {
        return null;
    }
};

export function OfferLocationLinksFloorChoices(props: IProps) {
    const {offerType, regionName, regionSlug} = props;
    const {offerListSubFilter} = useParams<Partial<IOfferFriendlySubFilterGeneralUrlParams>>();
    const location = useLocation();

    const query = parseSearch(location.search);
    const floorChoiceFromSlug = getFloorChoiceFromSlug(offerListSubFilter);
    const floorChoicesFromLocation =
        !isEmpty(query) && query.floor_choices && Array.isArray(query.floor_choices) && query.floor_choices.length > 0
            ? query.floor_choices.map((floorChoice) => parseInt(floorChoice, 10))
            : [];

    const floorChoices = props.availableFloorTypes.filter(
        (floorChoice) => floorChoice !== floorChoiceFromSlug && !floorChoicesFromLocation.includes(floorChoice)
    );
    const offerTypeText = offerType ? getOfferTypeNamePluralCapital(offerType) : "Nieruchomości";

    const replaceGroundWithGarden = (text: string) => text.replace("na parterze z ogródkiem", "z ogródkiem");
    return (
        <>
            {floorChoices.map((floorChoice, i) => (
                <OfferLocationLinksItem
                    disableSelfLinking
                    key={`fcl${i}`}
                    linkText={`${offerTypeText} ${replaceGroundWithGarden(getFloorChoiceText(floorChoice))} ${regionName}`}
                    url={rpAppLink.offer.listFriendlySubFilterGeneral({
                        friendlySlug: offerUrlBuilder({
                            type: offerType,
                            region: regionSlug
                        }).friendlySlug,
                        offerListSubFilter: getOfferListSubTypeByFloorChoice(floorChoice)
                    })}
                />
            ))}
        </>
    );
}
import {useLocation, useParams} from "react-router";

import {isEmpty} from "@pg-mono/nodash";
import {parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";
import {IOfferFriendlySubFilterGeneralUrlParams} from "@pg-mono/rp-routes";

import {FloorChoice} from "../../real_estate/types/FloorChoice";
import {getFloorChoiceText} from "../../real_estate/utils/get_floor_choice_text";
import {offerUrlBuilder} from "../helpers/friendly_offer_list/offer_url_builder";
import {getOfferTypeNamePluralCapital} from "../helpers/OfferType";
import {getFloorChoiceByOfferListSubType} from "../list/helpers/sub_type/transform/get_floor_choice_by_offer_list_sub_type";
import {getOfferListSubTypeByFloorChoice} from "../list/helpers/sub_type/transform/get_offer_list_sub_type_by_floor_choice";
import {OfferType} from "../types/OfferType";
import {OfferLocationLinksItem} from "./OfferListLocationLinksItem";

interface IProps {
    offerType: OfferType | null;
    regionName: string;
    regionSlug: string;
    availableFloorTypes: FloorChoice[];
}

const getFloorChoiceFromSlug = (offerListSubFilter?: string): FloorChoice | null => {
    try {
        return offerListSubFilter ? getFloorChoiceByOfferListSubType(offerListSubFilter) : null;
    } catch {
        return null;
    }
};

export function OfferLocationLinksFloorChoices(props: IProps) {
    const {offerType, regionName, regionSlug} = props;
    const {offerListSubFilter} = useParams<Partial<IOfferFriendlySubFilterGeneralUrlParams>>();
    const location = useLocation();

    const query = parseSearch(location.search);
    const floorChoiceFromSlug = getFloorChoiceFromSlug(offerListSubFilter);
    const floorChoicesFromLocation =
        !isEmpty(query) && query.floor_choices && Array.isArray(query.floor_choices) && query.floor_choices.length > 0
            ? query.floor_choices.map((floorChoice) => parseInt(floorChoice, 10))
            : [];

    const floorChoices = props.availableFloorTypes.filter(
        (floorChoice) => floorChoice !== floorChoiceFromSlug && !floorChoicesFromLocation.includes(floorChoice)
    );
    const offerTypeText = offerType ? getOfferTypeNamePluralCapital(offerType) : "Nieruchomości";

    const replaceGroundWithGarden = (text: string) => text.replace("na parterze z ogródkiem", "z ogródkiem");
    return (
        <>
            {floorChoices.map((floorChoice, i) => (
                <OfferLocationLinksItem
                    disableSelfLinking
                    key={`fcl${i}`}
                    linkText={`${offerTypeText} ${replaceGroundWithGarden(getFloorChoiceText(floorChoice))} ${regionName}`}
                    url={rpAppLink.offer.listFriendlySubFilterGeneral({
                        friendlySlug: offerUrlBuilder({
                            type: offerType,
                            region: regionSlug
                        }).friendlySlug,
                        offerListSubFilter: getOfferListSubTypeByFloorChoice(floorChoice)
                    })}
                />
            ))}
        </>
    );
}
